

let button = document.querySelectorAll("[data-submenu-toggle]");
let cart = document.querySelectorAll('.nav--cart');
let desk_logo = document.querySelector('.nav--desktop__logo');
let mobile_logo = document.querySelector('.nav--mobile__logo');
button.forEach(r => {
    r.addEventListener("click", function () {
        var e = r.parentNode,
            t = e.parentNode,
            u = t.parentNode,
            s = u.parentNode,
            v = s.parentNode;

        if (e.classList.contains("submenu-is-active")) {
            v.classList.add('background-white')
            button.forEach(l => {
                l.classList.remove('white--color');
            })
            cart.forEach(l => {
                l.classList.remove('white--color');
            })
            desk_logo.classList.remove('white--color');
            mobile_logo.classList.remove('white--color');
        } else {
            v.classList.remove('background-white')
            button.forEach(l => {
                l.classList.add('white--color');
            })
            cart.forEach(l => {
                l.classList.add('white--color');
            })
            desk_logo.classList.add('white--color');
            mobile_logo.classList.add('white--color');
        }
    })
})
